import { createAsyncThunk } from '@reduxjs/toolkit';
import { IState } from '../..';
import { httpService } from '../../..';
import { executeApiRequest } from '../../asyncUtils';
import { showFailedRequestDialogThunk } from '../../thunkUtils';
import { uiActionCreators } from '../../ui';
import { logisticsActionCreators } from '../logisticsActionCreators';

export const recalculateLoadValue = createAsyncThunk<void, { loadNumber: string }, { state: IState }>(
  'logistics/recalculateLoadValue',
  async ({ loadNumber }: { loadNumber: string }, { dispatch, getState, rejectWithValue }) => {
    dispatch(uiActionCreators.showSpinnerDialog());

    const response = await executeApiRequest<number>(() =>
      httpService.post(`/Logistics/Loads/${loadNumber}/RecalculateValue`)
    );

    if (response.requestFailed) {
      showFailedRequestDialogThunk(response, getState(), dispatch);
      rejectWithValue(response.exception?.message);
    } else if (response.value) {
      //
      dispatch(logisticsActionCreators.setLoadValue({ loadNumber, value: response.value }));
    }

    dispatch(uiActionCreators.hideSpinnerDialog());
  }
);
